/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chips, { Chip } from 'react-chips';
import _debounce from 'lodash/debounce';

class AssigneeSearch extends PureComponent {
  handleFetchSuggestions = _debounce((searchText, callback) => {
    const {
      onSearchUsers
    } = this.props;

    onSearchUsers(searchText, callback);
  }, 250);

  handleSelect = (chips) => {
    const {
      onChange
    } = this.props;

    onChange(chips);
  };
  
  renderSuggestion = user => (
    <span>
      {user.name}
    </span>
  );

  getValue = user => (
    user.name
  );

  filterSuggestions = (suggestion, searchText) => (
    suggestion.name.toLowerCase().indexOf(searchText) !== -1
  );

  renderChip = user => (
    <Chip>
      {user.name}
    </Chip>
  );

  render() {
    const {
      assignees
    } = this.props;

    return (
      <Chips
        value={assignees}
        onChange={this.handleSelect}
        renderChip={this.renderChip}
        getChipValue={this.getValue}
        suggestionsFilter={this.filterSuggestions}
        renderSuggestion={this.renderSuggestion}
        getSuggestionValue={this.getValue}
        fetchSuggestions={this.handleFetchSuggestions}
        placeholder="Enter a name..."
      />
    );
  }
}

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
AssigneeSearch.propTypes = {
  // Required props
  assignees: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  
  // Required methods
  onChange: PropTypes.func.isRequired,
  onSearchUsers: PropTypes.func.isRequired
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default AssigneeSearch;
